import depositsJson from './content/deposits.json';

export const depositsMock = {
    layoutType: 2,
    data: {
        name: 'deposits-and-withdrawals',
        areasList: [
            {
                id: 1,
                name: 'DepositsPage',
                componentName: 'Comp:DepositsPage',
                content: JSON.stringify(depositsJson)
            }
        ]
    }
};
